<template>
    <div id="app">
            <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
}
</script>

<style>
	body{
		margin: 0;
	}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #16203D;
  height: 100%;
}
body {
  margin: 0;
  padding: 0;
}
/* 隐藏谷歌 火狐，IE浏览器的滚动条 */
*::-webkit-scrollbar {
	display: none;
}
* {
	scrollbar-width: none;
}
* {
	-ms-overflow-style: none;
}
</style>
